/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type Package = {
  /**
   * The creation date of the package
   */
  createdAt: Date;
  /**
   * The deletion date of the package
   */
  deletedAt?: Date | undefined;
  /**
   * The description of the package. This contains HTML content.
   */
  description?: string | undefined;
  /**
   * The unsanitized, user-supplied description of the package. Limited markdown syntax is supported.
   */
  descriptionRaw?: string | undefined;
  /**
   * The ID of the package
   */
  id: string;
  /**
   * The asset ID of the image to show for this package
   */
  imageAssetId?: string | undefined;
  /**
   * The keywords of the package
   */
  keywords?: Array<string> | undefined;
  /**
   * The latest version of the package
   */
  latestVersion?: string | undefined;
  /**
   * The name of the package
   */
  name: string;
  /**
   * The ID of the organization that owns the package
   */
  organizationId: string;
  /**
   * The ID of the project that owns the package
   */
  projectId: string;
  /**
   * The summary of the package
   */
  summary?: string | undefined;
  /**
   * The title of the package
   */
  title?: string | undefined;
  /**
   * The last update date of the package
   */
  updatedAt: Date;
  /**
   * External URL for the package owner
   */
  url?: string | undefined;
};

/** @internal */
export const Package$inboundSchema: z.ZodMiniType<Package, unknown> = z.pipe(
  z.object({
    created_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    deleted_at: z.optional(
      z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
    ),
    description: z.optional(z.string()),
    description_raw: z.optional(z.string()),
    id: z.string(),
    image_asset_id: z.optional(z.string()),
    keywords: z.optional(z.array(z.string())),
    latest_version: z.optional(z.string()),
    name: z.string(),
    organization_id: z.string(),
    project_id: z.string(),
    summary: z.optional(z.string()),
    title: z.optional(z.string()),
    updated_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    url: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "created_at": "createdAt",
      "deleted_at": "deletedAt",
      "description_raw": "descriptionRaw",
      "image_asset_id": "imageAssetId",
      "latest_version": "latestVersion",
      "organization_id": "organizationId",
      "project_id": "projectId",
      "updated_at": "updatedAt",
    });
  }),
);

export function packageFromJSON(
  jsonString: string,
): SafeParseResult<Package, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => Package$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'Package' from JSON`,
  );
}
